module.exports = {
      id: "line-arrow-prev-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#line-arrow-prev",
      toString: function () {
        return this.url;
      }
    }